const dsp = state => state;

export default {
    dsp
};
